type GenericObject = { [key: string]: any }

export const COMPANIES_LOAD = 'COMPANIES_LOAD'
export const companiesLoad = (
  accountId: string,
  projectId: string
): CompaniesLoadAction => ({
  type: COMPANIES_LOAD
})

export const COMPANIES_LOAD_SUCCESS = 'COMPANIES_LOAD_SUCCESS'
export const companiesLoadSuccess = (
  companies: GenericObject
): CompaniesLoadSuccessAction => ({
  type: COMPANIES_LOAD_SUCCESS,
  companies
})

export const COMPANIES_LOAD_FAIL = 'COMPANIES_LOAD_FAIL'
export const companiesLoadFailure = (error): CompaniesLoadFailAction => ({
  type: COMPANIES_LOAD_FAIL,
  error
})

// INTERFACEs
export interface CompaniesLoadAction {
  type: typeof COMPANIES_LOAD
}

interface CompaniesLoadSuccessAction {
  type: typeof COMPANIES_LOAD_SUCCESS
  companies: GenericObject
}

interface CompaniesLoadFailAction {
  type: typeof COMPANIES_LOAD_FAIL
  error: any
}
